import React from "react";
import useBreakpoints from "../../util/useBreakpoints";

interface SpacerProps {
  size?: "xxs" | "xs" | "s" | "m" | "l" | "xl";
  mobileSize?: "xxs" | "xs" | "s" | "m" | "l" | "xl";
}

export default function Spacer({ size = "m", mobileSize = size }: SpacerProps) {
  const { currentBreakpoint } = useBreakpoints();

  const getSpacing = () => {
    if (currentBreakpoint === "mobile") {
      switch (mobileSize) {
        case "xxs":
          return "16px";
        case "xs":
          return "24px";
        case "s":
          return "36px";
        case "m":
          return "48px";
        case "l":
          return "64px";
        case "xl":
          return "110px";
      }
    } else {
      switch (size) {
        case "xxs":
          return "16px";
        case "xs":
          return "26px";
        case "s":
          return "42px";
        case "m":
          return "60px";
        case "l":
          return "74px";
        case "xl":
          return "100px";
      }
    }
  };

  return <div className="spacer" style={{ height: getSpacing(), width: "100%" }} />;
}
